import {
  Button,
  Modal,
  TextInputField,
  Flex
} from '@sequencehq/core-components'
import { useForm } from '@sequencehq/utils'
import {
  isPositiveInteger,
  numberWithLengthBetween,
  requiredAllowZero
} from '@sequencehq/utils/validation'
import { useState } from 'react'

export const CustomPaymentTermsModal = ({
  isOpen,
  setIsOpen,
  onSubmit,
  isPending = false,
  defaultValue
}: {
  setIsOpen: (value: boolean) => void
  onSubmit: (value: number) => void
  isPending?: boolean
  defaultValue?: number
  isOpen: boolean
}) => {
  const onClose = () => {
    setIsOpen(false)
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      data-testid="modal.customPaymentTerms"
    >
      <CustomPaymentTermsModalContent
        onClose={onClose}
        isPending={isPending}
        defaultValue={defaultValue}
        onSubmit={onSubmit}
      />
    </Modal>
  )
}

const CustomPaymentTermsModalContent = ({
  onClose,
  onSubmit,
  isPending,
  defaultValue
}: {
  onClose: () => void
  onSubmit: (value: number) => void
  isPending: boolean
  defaultValue?: number
}) => {
  const [showValidationErrors, setShowValidationErrors] = useState(false)

  const { fields, queries } = useForm<{ paymentTerms?: string }>({
    value: {
      paymentTerms:
        typeof defaultValue !== 'undefined' ? String(defaultValue) : undefined
    },
    showValidationErrors,
    fieldConfiguration: [
      {
        property: 'paymentTerms',
        validation: [
          isPositiveInteger,
          numberWithLengthBetween(1, 3),
          requiredAllowZero
        ]
      }
    ]
  })

  return (
    <>
      <Modal.Header withBorder>Payment terms</Modal.Header>
      <Modal.Content minHeight="auto">
        <Flex
          id="create-default-date-days"
          as="form"
          flexDirection="column"
          onSubmit={e => {
            e.preventDefault()
            setShowValidationErrors(true)
            if (typeof queries.formData.paymentTerms === 'undefined') return
            if (!queries.isValid) return
            onSubmit(Number(queries.formData.paymentTerms))
            onClose()
          }}
        >
          <TextInputField
            label="Number of days"
            data-testid="modal.customPaymentTerms.input"
            required
            autoFocus
            placeholder="0"
            validationErrors={fields.paymentTerms.validationErrors}
            value={fields.paymentTerms.value}
            onChange={e => {
              fields.paymentTerms.onChange(e.target.value)
            }}
          />
        </Flex>
      </Modal.Content>
      <Modal.Footer withBorder>
        <Button
          data-testid="modal.customPaymentTerms.cancel"
          variant="secondary"
          onClick={onClose}
        >
          Cancel
        </Button>

        <Button
          data-testid="modal.customPaymentTerms.submit"
          variant="primary"
          type="submit"
          form="create-default-date-days"
          disabled={isPending}
        >
          Save
        </Button>
      </Modal.Footer>
    </>
  )
}
